import React, { useEffect, useState, useContext } from "react";
import { Button, Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getAllApps, switchApp, deleteAppById } from "../api/api";
import { GlobalContext } from "../GlobalProvider";

const AppPage = () => {
    const [apps, setApps] = useState([]);
    const { currentApp, setCurrentApp, loginDetails } = useContext(GlobalContext);
    const navigate = useNavigate();

    const handleSwitchApp = async (app) => {
        try {
            const response = await switchApp({ userId: loginDetails.id, appId: app._id });
            const newToken = response.data.token;

            localStorage.setItem("token", newToken);

            setCurrentApp({
                id: app._id,
                name: app.name,
                description: app.description,
                adminApp: app.adminApp,
            });

            alert(`Switched to ${app.name} successfully!`);
        } catch (error) {
            console.error("Error switching app:", error);
            alert("Failed to switch app.");
        }
    };

    const handleDeleteApp = async (appId) => {
        if (window.confirm("Are you sure you want to delete this app?")) {
            try {
                await deleteAppById(appId);
                setApps((prevApps) => prevApps.filter((app) => app._id !== appId));
                alert("App deleted successfully!");
            } catch (error) {
                console.error("Error deleting app:", error);
                alert("Failed to delete app.");
            }
        }
    };

    useEffect(() => {
        const fetchApps = async () => {
            try {
                const response = await getAllApps();
                setApps(response.data.data);

                if (!currentApp && response.data.length > 0) {
                    setCurrentApp(response.data.data[0]);
                }
            } catch (error) {
                console.error("Error fetching apps:", error);
            }
        };

        fetchApps();
    }, [currentApp, setCurrentApp]);

    return (
        <Box sx={{ padding: "20px" }}>
            <Typography variant="h4" gutterBottom>
                Apps
            </Typography>
            {apps.length === 0 ? (
                <Box
                    sx={{
                        textAlign: "center",
                        marginTop: "50px",
                        padding: "20px",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#f9f9f9",
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                        No Apps Available
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
                        The Apps page is where you can view and manage monitoring applications for your IoT system.
                        Apps help you organize and track entities, sensors, and detections in one place.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                        To get started, click the button below to create your first app.
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate("/app-create")}
                    >
                        Create New App
                    </Button>
                </Box>
            ) : (
                <>
                    <Grid container spacing={2}>
                        {apps.map((app) => (
                            <Grid item xs={12} sm={12} md={12} key={app._id}>
                                <Card
                                    sx={{
                                        position: "relative",
                                        border:
                                            currentApp && currentApp.id === app._id
                                                ? "2px solid green"
                                                : "1px solid #ddd",
                                    }}
                                >
                                    {currentApp && currentApp.id === app._id && (
                                        <CheckCircle
                                            sx={{
                                                position: "absolute",
                                                top: 8,
                                                right: 8,
                                                color: "green",
                                            }}
                                        />
                                    )}
                                    <CardContent>
                                        <Typography variant="h6">{app.name}</Typography>
                                        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                            {app.description}
                                        </Typography>
                                        {!app.adminApp && (
                                            <>
                                                <Typography variant="body2">
                                                    <strong>Entities:</strong> {app.entities.length}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Geo-Located:</strong>{" "}
                                                    {app.entities.some((entity) => entity.isGeoLocated)
                                                        ? "Yes"
                                                        : "No"}
                                                </Typography>
                                            </>
                                        )}
                                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={() => handleSwitchApp(app)}
                                            >
                                                {currentApp && currentApp.id === app._id
                                                    ? "Current App"
                                                    : "Switch App"}
                                            </Button>
                                            {!app.adminApp && (
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    onClick={() => navigate(`/app/${app._id}/edit`)}
                                                >
                                                    Edit/View App
                                                </Button>
                                            )}
                                            {!app.adminApp && currentApp.adminApp && (
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => handleDeleteApp(app._id)}
                                                >
                                                    Delete App
                                                </Button>
                                            )}
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                    {
                        currentApp && currentApp.adminApp ?   <Button
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: "20px" }}
                        onClick={() => navigate("/app-create")}
                    >
                        Create New App
                    </Button> : null
                    }
                  
                </>
            )}
        </Box>
    );
};

export default AppPage;
